export const CODE_SENT = 'Код подтверждения отправлен на почту';
export const SUCCESS_AUTH = 'Вы успешно авторизованы';
export const PASSWORD_CHANGE_SUCCESS = 'Пароль успешно изменен';
export const SUCCESS_SIGNUP = 'Вы успешно зарегистрированы';
export const SOMETHING_WENT_WRONG = 'Что-то пошло не так. Попробуйте позже';

export const USER_NOT_FOUND = 'Пользователь не найден';
export const INCORRECT_CREDENTIALS = 'Неверный email или пароль.\nОбратите внимание: если вы уже были зарегистрированы раньше, необходимо пройти повторную регистрацию. Используйте тот же email, но придумайте новый пароль. Это сделано для повышения безопасности.';
export const USER_ALREADY_EXISTS = 'Пользователь уже существует';
export const INVALID_VERIFICATION_CODE = 'Неверный код подтверждения';
export const SERVER_ERROR = 'Ошибка сервера';
export const NOT_AUTHORIZED = 'Вы не авторизованы';
export const TOO_MANY_REQUESTS = 'Слишком много попыток, пожалуйста попробуйте позже';
export const USER_NOT_CONFIRMED = 'Вы не подтвердили email';
